import React from 'react';

import {
  styled,
  Paper
} from '@mui/material';

import { selectFields } from 'modules';
import useRouteLocation from 'modules/layer00/hooks/useRouteLocation';



const FloatingPaper = styled(Paper)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(2),
  left: 'calc(50vw)',
  transform: 'translateX(-50%)',
  width: '240px'
}));



const { FC: StoreSelectField } = selectFields.StoreSelectField.genComponentAndControllerGenerator({
  featuresEnabled: ['reportInventoryLevels'],
  types: ['wooCommerce', 'wooCommerce_buyWithAmazon', 'shopify' , 'cleoTier1' , 'telgoo5' , 'customizableFormat' , 'tMobileDevEdge']
});

export interface IProps {
  selectedStoreId: string;
  onChange: (storeId: string) => void;
}

export const FC: React.FC<IProps> = props => {
  // getting route location
  const { isMatched: fromPartner } = useRouteLocation('partner');

  return (
    <FloatingPaper
      sx={{
        paddingY: 1,
        paddingX: 2,
        borderRadius: 24,
        background: theme => theme.palette.primary.light
      }}
      elevation={4}>
      <StoreSelectField
        label="Select Store"
        disableDefaultMargins
        disableClearable={fromPartner ? true : false}
        selectProps={{
          type: 'singleSelect',
          value: {
            id: props.selectedStoreId,
            displayName: ''
          },
          onChange: val => props.onChange(val?.id ?? '')
        }} />
    </FloatingPaper>
  );
};
